import type { RouteRecordRaw } from "vue-router";

const accountRoutes: RouteRecordRaw[] = [
  {
    path: "/summary/view",
    name: "view-summary",
    component: () => import("@/views/Account/AccountSummaryRouteView.vue"),
    meta: {
      title: "Account Summary",
      requiresAuth: true,
      accountPermission: "summary",
    },
  },
  {
    path: "/profile/view",
    name: "view-profile",
    component: () => import("@/views/Account/AccountProfileRouteView.vue"),
    meta: {
      title: "Profile",
      requiresAuth: true,
      accountPermission: "profile",
    },
  },
  {
    path: "/addresses/view",
    name: "view-addresses",
    component: () => import("@/views/Account/AccountAddressesRouteView.vue"),
    meta: {
      title: "Address Book",
      requiresAuth: true,
      accountPermission: "addresses",
    },
  },
  {
    path: "/account/buyers",
    name: "view-buyers",
    component: () => import("@/views/Account/AccountBuyersRouteView.vue"),
    meta: {
      title: "Buyers",
      requiresAuth: true,
      accountPermission: "buyers",
    },
  },
  {
    path: "/logins/view",
    name: "view-logins",
    component: () => import("@/views/Account/AccountLoginHistoryRouteView.vue"),
    meta: {
      title: "Login History",
      requiresAuth: true,
      accountPermission: "loginHistory",
    },
  },
  {
    path: "/patronage/view",
    name: "view-patronage",
    component: () => import("@/views/Account/ViewPatronage.vue"),
    meta: {
      title: "Patronage",
      requiresAuth: true,
      accountPermission: "patronage",
    },
  },
];

export default accountRoutes;
